<template>
    <ul id="list-tasks">
      <li>
        <div class="fh lc" style="width: 630px; height: 100px; margin-bottom: 10px; background: #ffffff;  
                                  border-style: solid; border-width: 1px; border: 1px solid #dddddd;
                                  box-shadow: 1px 1px 2px #dddddd;">
          <div class="fh cc" style="width: 15%; height: 100%;">
            <img id="imagenProducto" :src="imagenProducto" style="width: 90%; height: 90%; object-fit: contain"/> 
          </div>
          <div class="fv lt" style="width: 65%; height: 100%">
              <div class="fh lt" style="width: 100%; height: 20%; margin-left:5px; margin-top: 3px; font-size: 14px; font-weight:500; color: #656E76;">
                {{item.Nombre}}
              </div>
              <div class="fh lt" style="width: 100%; height: 50%; margin-left:5px; margin-top: 3px; font-size: 12px; color: #656E76;">
                {{item.Observacion}}
              </div>
              <div class="fv lc" style="height: 30%;">
                <div class="fh lt" style="width: 100%; font-weight: bold; color: #656E76; margin-left:5px">
                    <div class="fh lt" style="font-size: 10px; width: 120px">
                        {{precioHabitualLabel}}
                    </div>
                    <div class="fh lt" style="font-size: 11px; width: 120px; text-decoration:line-through;">
                        {{moneyLabelPrecioHabitual}}{{getPrecioHabitual | formatMoney}}
                    </div>
                    <div class="fh rt" style="font-size: 10px; width: 70px; ">
                        Valido desde:
                    </div>
                    <div class="fh lt" style="font-size: 10px; margin-left:10px;">
                        {{getFechaDesde}}
                    </div>
                </div>
                <div class="fh lt" style="width: 100%; font-weight: bold; color: #656E76; margin-left:5px">
                    <div class="fh lt" style="font-size: 10px; width: 120px">
                        Precio Promocional:
                    </div>
                    <div class="fh lt" style="font-size: 11px; width: 120px;">
                        {{moneyLabelPrecioPromocional}}{{getPrecioPromocional | formatMoney}}
                    </div>  
                    <div class="fh rt" style="font-size: 10px; width: 70px;">
                        hasta:
                    </div>
                    <div class="fh lt" style="font-size: 10px; margin-left:10px;">
                        {{getFechaHasta}}
                    </div>
              </div>
            </div>
          </div>
          <div class="fv cc" style="width: 20%; height: 100%;">
            <div class="fh rt" v-show='showDescuentos' style="font-size: 10px; background: #F7A541; color: #ffffff;
                                                              border-radius: 50%; padding:5px; margin-bottom: 3px">
                {{porcentajeDescuento}}
            </div>
            <button id="btnAgregar" @click="btnAgregar">AGREGAR A PEDIDO</button>
          </div>
        </div>
      </li>
    </ul>
  </template>
  
   
  <script>
    import axios from 'axios'
    import moment from 'moment'
  
    
    export default {
      name: 'item-promocion',
      props: ['item'],
  
      data() {
        return {
          showDescuentos:true,
          precioHabitualLabel:''
        }
      },

      computed: {
        moneyLabelPrecioHabitual() {
          if (this.item.DescuentoPorcentaje > 0) {
            if (this.item.Moneda == 2) {
              return 'U$S ' 
            }
            else {
              return '$ ' 
            }
          }
          else {
            return '' 
          }
        },
        moneyLabelPrecioPromocional() {
          if (this.item.Moneda == 2) {
            return 'U$S ' 
          }
          else {
            return '$ ' 
          }
        },
        getPrecioHabitual () {
          if (this.item.DescuentoPorcentaje > 0) {
            return (this.conversionMonedaProducto(this.item.PrecioHabitual)).toFixed(2)
          }
          else {
            return ''
          }
        },
        getPrecioPromocional () {
          return (this.conversionMonedaProducto(this.item.PrecioPromocional)).toFixed(2)
        },
        getFechaDesde () {
          var millis = moment(this.item.FechaInicio, "YYYY-MM-DDTHH:mm:ss").toDate().getTime()
          return moment(millis).format("DD/MM/YYYY")
        },
        getFechaHasta () {
          var millis = moment(this.item.FechaFin, "YYYY-MM-DDTHH:mm:ss").toDate().getTime()
          return moment(millis).format("DD/MM/YYYY")
        },
        porcentajeDescuento() {
          if (this.item.DescuentoPorcentaje > 0) {
            this.showDescuentos = true
            this.precioHabitualLabel = 'Precio Habitual:'
          }  
          else {
            this.showDescuentos = false
            this.precioHabitualLabel = ''
          }
          //return '-' + Math.round(this.item.DescuentoPorcentaje) + '%'
          return '-' + this.item.DescuentoPorcentaje + '%'
        },
        imagenProducto() {
          if (this.item.ImagenUrl != null) {
            return this.item.ImagenUrl
          }
          else {
            return '/dist/placeholder-producto.png'
          } 
        } 
      },



      methods: {

        btnAgregar () {
          this.$emit('setItemPromocion', this.item.Id);
         },
        conversionMonedaProducto(monto) {
            var montoConv = 0.0
            if (this.$store.state.pedido.idMoneda != this.$store.state.user.cliente.ListaPrecioMoneda) {
                if (this.$store.state.pedido.idMoneda == 2) {
                    montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
                }
                else if (this.$store.state.pedido.idMoneda == 1) {
                    montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
                }
            }
            else {
                montoConv  = monto 
            }
            return montoConv
        }
      }
  
    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
  
    
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
  #s1{
  width: 12%;
  height: 100%;
  background: #ffffff;  
  display: flex;
  justify-content: center;  
  align-items: center;  
  }
  
  #s2{
    width: 70%;
    height: 100%;
    background: #ffffff;  
  }
  
  #s3{
    width: 18%;
    height: 100%;
    background: #ffffff;  
    display: flex;
    justify-content: center;  
    align-items: center;  
  }
  
  #titulo{
    font-size: 14px;
    color: #656E76;
    margin-top: 8px;
    font-weight: 500;
  }
  
  #descrip{
    font-size: 9px;
    color: #656E76;
    height: 12px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  
  .label{
    font-size: 10px;
    color: #656E76;
    font-weight: bold;
    background-color: #ffffff;
    width: 90px;
    float: left;
  }
  
  .value{
    font-size: 10px;
    font-weight: bold;  
    color: #656E76;
    width: 70px;
    background-color: #ffffff;
    float: left;
  }
  
  #label-subtotal{
    font-size: 10px;
    font-weight: bold;
    color: #656E76;
    margin-left: 10%;
    width: 110px;
    background-color: #ffffff;
    float: left;
  }
  

  #btnAgregar{
    width: 85px;
    height: 22px;
    font-size: 7px;
    border-style: solid;
    border:none; 
    background: #44C7F4; 
    border-radius: 20px;  
    color: #ffffff;
    outline: none;
  }
            
  #btnAgregar:hover { cursor: pointer; }
      


  
 </style>


// WEBPACK FOOTER //
// src/components/views/promociones/itemPromociones.vue